import SewingPatternInterface from './sewing-pattern.interface';
import {SafeUrl} from "@angular/platform-browser";

export default class SewingPatternProject {
    public id: string;
    public updatedAt?: number;
    public url?: string|SafeUrl;

    constructor(public name: string, public sewingPattern: SewingPatternInterface, public uri: string) { }
}
